<script src="assets/js/Audio/audioText.js"></script>
<app-centre-small-opener [dragCheck] = "true">
        <div class="drag-dialog-content" contentContainer>
                <textarea rows = "18" id = "drag-drop-field" matInput placeholder="Speech to text" class="text-area-auto-height" (keyup) = "getFieldContent($event)" [value] = "dialogContent == undefined ? '' : dialogContent" ></textarea>
        </div>
        <button mat-raised-button actions color = "primary" (click) = "doClose()" mat-dialog-close class="text-uppercase">close</button>
    </app-centre-small-opener>
 
